module.exports = __webpack_public_path__ + "4e8371e5c6c429e3976a60b194ccf4a7.png";